import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { getAllBlogs } from "../features/ads/adsSlice";
import { Link } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { Navigation, Pagination, Autoplay } from "swiper/modules";

const AdComponent = () => {
  const dispatch = useDispatch();
  const { blog } = useSelector((state) => state.blog);
  useEffect(() => {
    dispatch(getAllBlogs());
  }, [dispatch]);

  const filteredBlogs = blog
    .filter((item) => item.category === "Special Offers")
    .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));

  const getSubcategoryRoute = (sub) => {
    const s = (sub || "").toLowerCase();
    if (s.includes('medicine')) return "/medicines";
    if (s.includes('otc')) return "/otc";
    if (s.includes('vitamin')) return "/vitamins";
    if (s.includes('mother') || s.includes('baby')) return "/mother-baby";
    return "/shop";
  };

  return (
    <div className="w-full relative px-2 py-2">
      <style>{`
        .ad1-swiper .swiper-pagination-bullet {
          width: 6px; height: 6px;
          background: #cbd5e1; opacity: 1;
          transition: all 0.3s;
        }
        .ad1-swiper .swiper-pagination-bullet-active {
          width: 20px; border-radius: 4px;
          background: #14b8a6;
        }
        .ad1-slide-card {
          background: #fff;
          border-radius: 18px;
          overflow: hidden;
          border: 1px solid #f1f5f9;
          transition: border-color 0.2s, box-shadow 0.2s, transform 0.25s;
          height: 100%;
          display: flex;
          flex-direction: column;
          text-decoration: none;
          box-shadow: 0 2px 10px rgba(0,0,0,0.03);
        }
        .ad1-slide-card:hover {
          border-color: #14b8a6;
          box-shadow: 0 8px 24px rgba(13,148,136,0.08);
          transform: translateY(-3px);
        }
        .ad1-slide-img {
          width: 100%;
          height: 160px;
          object-fit: cover;
          display: block;
        }
        .ad1-slide-body {
          padding: 14px;
          flex: 1;
          display: flex;
          flex-direction: column;
        }
        .ad1-slide-tag {
          font-size: 10px;
          font-weight: 800;
          color: #14b8a6;
          text-transform: uppercase;
          letter-spacing: 0.1em;
          margin-bottom: 6px;
        }
        .ad1-slide-title {
          font-size: 14px;
          font-weight: 800;
          color: #0f172a;
          line-height: 1.3;
          margin-bottom: 6px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .ad1-slide-desc {
          font-size: 12px;
          color: #64748b;
          line-height: 1.5;
          margin: 0;
          overflow: hidden;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
        }
        .ad1-slide-cta {
          margin-top: auto;
          padding-top: 12px;
          font-size: 11px;
          font-weight: 800;
          color: #14b8a6;
          text-transform: uppercase;
          letter-spacing: 0.06em;
          display: flex;
          align-items: center;
          gap: 4px;
        }
        /* Section Header */
        .ad1-section-header {
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-bottom: 16px;
          padding-bottom: 12px;
          border-bottom: 1px solid #f1f5f9;
        }
        .ad1-section-title {
          font-family: 'Plus Jakarta Sans', 'Inter', sans-serif;
          font-size: 18px;
          font-weight: 900;
          color: #0f172a;
          letter-spacing: -0.03em;
          display: flex;
          align-items: center;
          gap: 8px;
        }
        .ad1-section-badge {
          background: #f0fdfa;
          border: 1px solid #ccfbf1;
          border-radius: 8px;
          padding: 3px 10px;
          font-size: 10px;
          font-weight: 800;
          color: #0d9488;
          text-transform: uppercase;
          letter-spacing: 0.08em;
        }
        .ad1-view-all {
          font-size: 12px;
          font-weight: 700;
          color: #14b8a6;
          text-decoration: none;
          display: flex;
          align-items: center;
          gap: 4px;
          transition: gap 0.15s;
        }
        .ad1-view-all:hover { gap: 8px; }
      `}</style>

      {/* Section Header */}
      <div className="ad1-section-header">
        <div className="ad1-section-title">
          <span className="ad1-section-badge">Live</span>
          Special Offers
        </div>
        <Link to="/special-offer" className="ad1-view-all">
          See all
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><path d="m9 18 6-6-6-6"/></svg>
        </Link>
      </div>

      {filteredBlogs.length === 0 ? null : (
        <Swiper
          modules={[Navigation, Pagination, Autoplay]}
          spaceBetween={14}
          slidesPerView={2}
          autoplay={{ delay: 5000, disableOnInteraction: false }}
          pagination={{ clickable: true }}
          breakpoints={{
            320: { slidesPerView: 1.7, spaceBetween: 10 },
            480: { slidesPerView: 2.1, spaceBetween: 12 },
            640: { slidesPerView: 2.5, spaceBetween: 14 },
            768: { slidesPerView: 3.2, spaceBetween: 16 },
            1024: { slidesPerView: 4.2, spaceBetween: 20 },
          }}
          className="pb-8 ad1-swiper"
        >
          {filteredBlogs.map((ad, index) => (
            <SwiperSlide key={index} className="h-auto">
              <Link
                to={ad.path || getSubcategoryRoute(ad.subcategory)}
                className="ad1-slide-card"
              >
                <img
                  src={ad.images?.[0]?.secure_url}
                  alt={ad.title}
                  className="ad1-slide-img"
                />
                <div className="ad1-slide-body">
                  <div className="ad1-slide-tag">Special Offer</div>
                  <div className="ad1-slide-title">{ad.title}</div>
                  <p
                    className="ad1-slide-desc"
                    dangerouslySetInnerHTML={{ __html: ad.description }}
                  />
                  <div className="ad1-slide-cta">
                    Shop now
                    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><path d="m9 18 6-6-6-6"/></svg>
                  </div>
                </div>
              </Link>
            </SwiperSlide>
          ))}
        </Swiper>
      )}
    </div>
  );
};

export default AdComponent;
